import useUserStore from 'store/user';

import CopperIcon from 'assets/images/copper_icon.png';
import SilverIcon from 'assets/images/silver_icon.png';
import GoldIcon from 'assets/images/gold_icon.png';
import useAudio from 'hooks/useAudio';
import ButtonCoin from 'components/form/ButtonCoin';
import useFlyingAnimation from 'hooks/useFlyingAnimation';
import { useEffect, useState } from 'react';
import useIncrementNumber from 'hooks/useIncrementNumber';
import { readEarnMorePoints } from '@/api/balancer/read';
import type { ReadPointEarnMoreType } from '@/types';
import { createAchieve } from '@/api/balancer/create';
import { formatPoint } from '@/utils/format';
import { useNavigate } from 'react-router-dom';

export default function EarnMorePoints() {
  // store
  const { point, ids } = useUserStore();

  // hooks
  const { handlePlay } = useAudio('/sounds/click_sound.mp3');
  const { startAnimation } = useIncrementNumber();
  const { animationKey, buttonRef, isFlying, flyStyle, handleClick } = useFlyingAnimation();
  // state
  const [list, setList] = useState<ReadPointEarnMoreType[] | []>([]);

  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      if (!ids.pointId) {
        navigate('/');
        return;
      }
      const re = await readEarnMorePoints(ids);
      setList(re.data);
    })();

    return () => {};
  }, []);

  // method
  const handleClickEarn = async (item: ReadPointEarnMoreType) => {
    if (isFlying) return;
    handlePlay();

    // setIsLoading(true);

    await createAchieve({ achieveSetId: item.achieveSetId }, ids);

    // 숫자 올라가는 애니메이션
    startAnimation(Number(item.amount));

    /**
     * 획득 할 수 있는 버튼을 바로 비활성화 처리
     * 서버에서 받고 다시 동기화하려면 시간이 걸리니
     * 일단 화면상으로만 처리
     */
    setList((prev) =>
      prev.map((el) => {
        if (el.achieveSetId === item.achieveSetId) {
          return {
            ...el,
            achieved: true,
          };
        }
        return el;
      }),
    );
  };

  return (
    <>
      <div className="border-b-3 flex h-[53px] items-center gap-[6px] border-[#B2B2B2] bg-[#FF6535] px-[16px] py-[20px]">
        <div className="mb-[3px] h-[8px] w-[8px] rounded-full bg-white" />
        <h1 className="text-[15px] font-[800] text-white">EARN MORE POINTS</h1>
      </div>

      <div className="h-[calc(100dvh-117px)] bg-white px-[10px] py-[17px]">
        <div className="brown-scrollbar flex max-h-[calc(100dvh-151px)] flex-col gap-[10px] overflow-y-auto pl-[6px] pr-[9px]">
          {list.map((item: ReadPointEarnMoreType, index) => (
            <div
              key={`item.title${index}`}
              className={`flex items-center gap-[7px] rounded-[100px] ${Number(item.requireValue) <= point ? 'border-3 border-[#FF6839]' : 'border-2 border-[#6B2D19]'} px-[17px] py-[15px] text-[10px]`}
            >
              <img
                src={Number(item.amount) === 10 ? CopperIcon : Number(item.amount) === 30 ? SilverIcon : GoldIcon}
                className="h-[40px] w-[40px]"
              />
              {/* <div className="relative h-[40px] w-[40px]">
                <img
                  src={Number(item.amount) === 10 ? CopperIcon : Number(item.amount) === 30 ? SilverIcon : GoldIcon}
                  className="h-full w-full"
                />
                <span className="absolute inset-0 flex items-center justify-center text-xs font-bold text-white">
                  {item.amount}
                </span>
              </div> */}

              <div className="flex flex-col gap-[4px]">
                <span className="text-[12px] font-[800] leading-none text-[#6B2D19]">{item.title}</span>
                <span className="text-[10px] leading-tight text-[#4F4F4F]">{item.describe}</span>
              </div>

              <div className="ml-auto h-[28px]">
                {/* <Button
                  onClick={handleClickEarn}
                  disabled={item.condition > point}
                  text="Earned"
                  className="px-[18px]"
                /> */}
                {/* 이미 획득 */}
                {item.achieved ? (
                  <ButtonCoin
                    onClick={() => {
                      handleClickEarn(item);
                    }}
                    disabled={item.achieved}
                    text="Completion"
                    className="bg-[blue] px-[18px]"
                  />
                ) : (
                  <ButtonCoin
                    onClick={() => {
                      handleClickEarn(item);
                    }}
                    disabled={point < Number(item.requireValue)}
                    text={point < Number(item.requireValue) ? 'Earned' : 'Earn'}
                    className="px-[18px]"
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
